import { useState } from 'react'
import Joyride, { CallBackProps, Step, Styles, STATUS } from 'react-joyride'

export const Tour = ({
    steps,
    spotlightPadding = 0,
    run,
}: {
    steps: Step[]
    spotlightPadding?: number
    run: boolean
}) => {
    const [stepIndex, setStepIndex] = useState(0)
    const [runTour, setRunTour] = useState(run)

    const handleJoyrideCallback = (data: CallBackProps) => {
        const { index, status, type } = data

        if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
            setStepIndex(0)
            setRunTour(false)
        } else if (type === 'step:after') {
            setStepIndex(index + 1)
        }
    }

    const isLastStep = stepIndex === steps.length - 1

    return (
        <Joyride
            steps={steps}
            continuous
            run={run}
            stepIndex={stepIndex}
            callback={handleJoyrideCallback}
            showSkipButton={steps.length > 1}
            showProgress
            styles={customStyles}
            spotlightPadding={spotlightPadding}
            locale={{
                last: 'Close',
                nextLabelWithProgress: isLastStep ? 'Close' : 'Next',
            }}
        />
    )
}

const customStyles: Styles = {
    options: {
        arrowColor: '#071727',
        backgroundColor: '#071727',
        overlayColor: 'rgba(255, 255, 255, 0.15)',
        primaryColor: '#4c6ef5',
        textColor: '#ffffff',
        width: 550,
        zIndex: 999,
    },
    beacon: { display: 'none' },
    beaconInner: {},
    beaconOuter: {},
    overlay: {},
    overlayLegacy: {},
    overlayLegacyCenter: {},
    spotlight: {
        borderRadius: 0,
        boxShadow: '0 0 0 1px #b1b1b1',
    },
    spotlightLegacy: {},
    tooltip: {
        borderRadius: 2,
        padding: 0,
    },
    tooltipContainer: {
        textAlign: 'left',
        padding: '16px',
        paddingBottom: 0,
    },
    tooltipTitle: {
        fontSize: 14,
        marginBottom: '4px',
        fontWeight: 700,
        color: '#ffffff',
        margin: 0,
    },
    tooltipContent: {
        padding: 0,
        fontSize: 16,
        lineHeight: 1.6,
        color: '#e8eaed',
    },
    tooltipFooter: {
        paddingTop: 12,
        padding: 16,
        marginTop: 0,
    },
    buttonNext: {
        backgroundColor: '#2450BF',
        borderRadius: 2,
        color: '#ffffff',
        fontSize: 13,
        fontWeight: 500,
        width: '145px',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        height: '30px',
        lineHeight: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        padding: 0,
    },
    buttonSkip: {
        width: '140px',
        color: '#fff',
        height: '30px',
        lineHeight: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 13,
        fontWeight: 500,
        backgroundColor: 'rgba(36, 80, 191, 0.2)',
        cursor: 'pointer',
        border: '1px solid #2450BF',
        borderRadius: 2,
        marginRight: 8,
        padding: 0,
    },
    buttonBack: {
        display: 'none',
    },
    tooltipFooterSpacer: {
        display: 'contents',
    },
    buttonClose: {
        display: 'none',
    },
}
